import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../library/editors/elements/d-checkbox.js';
import '../../library/editors/elements/d-edit-textarea.js';
import '../../library/elements/d-section.js';
import { BaseDialog } from 'src/library/components/BaseDialog.js';
import { t } from 'src/i18n';
import type { DeleteMeetingOccurrenceDialogInput } from './delete-meeting-occurrence-dialog-input';
import type { DeleteMeetingOccurrenceDialogResult } from './delete-meeting-occurrence-dialog-result';
import type { DialogActionInput } from '../../library/components/DialogActionInput';

/**
 *
 * USAGE:
 *    d-event-view
 *
 */
@customElement('delete-meeting-occurrence-dialog')
export class DeleteMeetingOccurrenceDialog extends BaseDialog<
  DeleteMeetingOccurrenceDialogInput,
  DeleteMeetingOccurrenceDialogResult
> {
  @property({ type: Boolean })
  noticeSent = false;
  @property({ type: Boolean })
  reportWritten = false;
  @property({ type: Number })
  width = 400;

  protected get calculatedTitle(): string {
    return t('meetings.deleteMeetingTitle');
  }

  protected get calculatedFooterActions(): DialogActionInput[] {
    return [
      { name: t('content.cancel'), action: 'cancel' },
      { name: t('content.delete'), action: 'delete', main: true },
    ];
  }

  private get info() {
    if (this.reportWritten) {
      return t('meetings.deleteWithReportInfo');
    }
    if (this.noticeSent) {
      return t('meetings.deleteWithNoticeInfo');
    }
    return '';
  }

  renderBody() {
    return html`
      <d-section>
        <d-view-info .content=${this.info}></d-view-info>
      </d-section>
    `;
  }

  protected fetchResult(detail: string): DeleteMeetingOccurrenceDialogResult {
    this.show = false;
    return { action: detail };
  }

  protected initializeDialog(input: DeleteMeetingOccurrenceDialogInput) {
    this.noticeSent = input.noticeSent;
    this.reportWritten = input.reportWritten;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'delete-meeting-occurrence-dialog': DeleteMeetingOccurrenceDialog;
  }
}
